import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Button, IconButton, Modal, Typography } from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';

interface InspectionModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  pdfFile: any;
  setPdfFile: Dispatch<SetStateAction<any>>;
  handleFileChange: any;
  handleDrop: any;
  handlePdfUpload: any;
  handleSubmit: any;
}

export default function InspectionReportModal({
  open,
  onClose,
  setOpen,
  pdfFile,
  setPdfFile,
  handleFileChange,
  handleDrop,
  handlePdfUpload,
  handleSubmit,
}: InspectionModalProps) {
  const [reportUrl, setReportUrl] = useState<string>('');

  return (
    <Modal
      className="modal fcDetail_modal"
      id="fcDetailModal"
      aria-labelledby="fcDetail-modal-title"
      aria-describedby="fcDetail-modal-description"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog" style={{ maxWidth: '680px' }}>
        <div className="modal-body">
          <div className="btn-close" onClick={() => setOpen(false)}>
            <CloseIcon />
          </div>
          <div className="modal_title">
            <h2>Inspection Report</h2>
          </div>

          {!pdfFile ? (
            <div
              className="pdf-upload-box"
              onClick={() => document.getElementById('pdfInput')?.click()}
              onDragOver={(event) => event.preventDefault()}
              onDrop={handleDrop}
            >
              <CloudUploadIcon fontSize="large" />
              <Typography variant="h6">Click to Upload or Drag & Drop</Typography>
              <Typography variant="body2" color="textSecondary">
                Only PDF files are allowed
              </Typography>
              <input
                type="file"
                id="pdfInput"
                accept="application/pdf"
                onChange={handlePdfUpload}
                hidden
              />
            </div>
          ) : (
            /* Show PDF preview after upload */
            <div className="pdf-preview">
              <PictureAsPdfIcon className="pdf-icon" fontSize="large" />
              <Typography variant="body2">{pdfFile.name}</Typography>
              <IconButton onClick={() => setPdfFile(null)} className="delete-btn">
                <CloseIcon color="error" />
              </IconButton>
            </div>
          )}
          <div className="footer_btn_flex">
            <Button
              className="btn btn_highlight"
              onClick={() => {
                // setError(false);

                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn_secondary"
              onClick={() => {
                setOpen(false);
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
